/**
 * This lives in its own file because: Previously was in the workbook-map-view, but it was imported from the add-timeline-layer-action
 * which was imported from the toolbar.js which was imported from any map (such as server cmd or client cmd maps) this meant that the
 * initializing code from workbook-map-view (the code below + more code) was executed from completely workbook unrelated maps,
 * and so we split it and moved it here, now this still executes from server and client commands maps, but it's less code
 * (the "more code" was removed), so it causes less problems
 *
 * Receives events from the workbook-map-parent-post-message-api.js.
 *
 * Listeners to these events are set in child classes.
 */

import { DEFAULT_MAP_CONFIG_ID } from 'cadenza/map/custom/map-constants';
import {
  WorkbookIframePostMessageApi
} from 'cadenza/workbook/view/view-content/workbook-iframe-post-message-api';
import {
  WorkbookMapPostMessageTypes
} from 'cadenza/workbook/view/view-content/workbook-post-message-types.js';
import { routingContext } from 'cadenza/map/routing/routing-context';
import { RoutingEvent } from 'cadenza/map/routing/routing-constants';

class WorkbookMapIframePostMessageApi extends WorkbookIframePostMessageApi {

  constructor (options) {
    super(options);
    this.addEventListener(WorkbookMapPostMessageTypes.ROUTE_SAVED_TO_REPOSITORY, () => {
      routingContext.getEventBus().dispatchEvent(RoutingEvent.ROUTING_STOPPED);
    });
    this.addEventListener(WorkbookMapPostMessageTypes.SAVE_ROUTE_DIALOG_CLOSED, event => {
      routingContext.getEventBus().dispatchEvent(new CustomEvent(RoutingEvent.ROUTE_DIALOG_CLOSED, { detail: event.detail }));
    });
  }

  sendLayersInRangeChanged (inRangeLayersIDs) {
    return this.request({
      type: WorkbookMapPostMessageTypes.LAYERS_IN_RANGE_CHANGED,
      detail: { inRangeLayersIDs }
    });
  }

  openAddWmsLayerDialog (srsCode) {
    return this.request({
      type: WorkbookMapPostMessageTypes.OPEN_ADD_WMS_LAYER_DIALOG,
      detail: { srsCode }
    });
  }

  sendScaleChanged (scale) {
    return this.request({
      type: WorkbookMapPostMessageTypes.SCALE_CHANGED,
      detail: { scale }
    });
  }

  sendTimeline3dEnabled (viewId, timeline3dEnabled) {
    return this.request({
      type: WorkbookMapPostMessageTypes.SET_TIMELINE_3D_ENABLED,
      detail: { viewId, timeline3dEnabled }
    });
  }

  timelinesChanged (timelinesResult) {
    return this.request({
      type: WorkbookMapPostMessageTypes.TIMELINES_CHANGED,
      detail: { timelinesResult }
    });
  }

  maxDisplayableTimelinePointsExceeded (exceeded) {
    return this.request({
      type: WorkbookMapPostMessageTypes.MAX_DISPLAYABLE_TIMELINE_POINTS_EXCEEDED_CHANGED,
      detail: { exceeded }
    });
  }

  openTimelinePlayer (mapViewId) {
    return this.request({
      type: WorkbookMapPostMessageTypes.SHOW_TIMELINE_PLAYER,
      detail: { mapViewId }
    });
  }

  openPrintMapDialog (viewId, extent, srs, mapSize, mapScale) {
    return this.request({
      type: WorkbookMapPostMessageTypes.PRINT_MAP_DIALOG,
      detail: { viewId, extent, srs, mapSize, mapScale }
    });
  }

  closeTimelinePlayer () {
    return this.request({
      type: WorkbookMapPostMessageTypes.CLOSE_TIMELINE_PLAYER
    });
  }

  refreshToolbarButton3D (refreshOptions) {
    return this.request({
      type: WorkbookMapPostMessageTypes.REFRESH_TOOLBAR_3D_BUTTON,
      detail: { refreshOptions }
    });
  }

  openSaveRouteDialog (dialogOptions) {
    return this.request({
      type: WorkbookMapPostMessageTypes.SHOW_SAVE_ROUTE_DIALOG,
      detail: dialogOptions
    });
  }

  mapInitialized (workbookMap) {
    return this.request({
      type: WorkbookMapPostMessageTypes.MAP_INITIALIZED,
      detail: { srs: workbookMap.map.getView().getProjection().getCode() }
    });
  }

  openPanel (panelId) {
    return this.request({
      type: WorkbookMapPostMessageTypes.SHOW_PANEL,
      detail: { panelId }
    });
  }

}

const initParams = {
  workbookMapConfig: document.getElementById(DEFAULT_MAP_CONFIG_ID)?.value
};

// Needed for communication with parent frame
const api = new WorkbookMapIframePostMessageApi({ initParams });
export { api as workbookMapIframeApi };
